export const name = 'gzField';
export default function gzField(
  // Directive angular dependencies
  $compile,
  $gzFields,
  $sanitize
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      id: '@',
      options: '=',
      record: '=',
      value: '=?',
    },
    template: require('./field.jade'),
    link: fieldLink,
    controller: fieldController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function fieldLink(scope, element, attrs) {
    let renderValue;
    let rawValue;
    let column = _.find(scope.vm.options.columns, {id: scope.vm.id});

    if (scope.vm.value) {
      rawValue = scope.vm.value;
    }
    else {
      let path = _.get(column, 'field.path');
      if (path) {
        rawValue = _.get(scope.vm.record, path);
      }
    }

    let classes = [];
    let classRenderer = _.get(column, 'field.callbacks.classRenderer');
    if (classRenderer) {
      classes = classRenderer(rawValue, scope.vm.record, column);
    }

    let value =  $gzFields.getValue(rawValue, scope.vm.record, column);
    _.set(scope, 'gzColumn.'+column.id, column);
    _.set(scope, 'gzValue.'+column.id, rawValue);
    if (value !== null) {
      renderValue = '<div class="gz-field ';
      _.forEach(classes, myClass => {
        renderValue += myClass + ' ';
      });

      if (column.type === 'string') {
        value = $sanitize(value);
      }

      renderValue += `" gz-auto-tooltip>${value}</div>`;
    }

    let myElement = $compile(renderValue)(scope);
    element.append(myElement[0]);
  }

  /** @ngInject */
  function fieldController(
    // Controller angular dependencies
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;
    vm.$onInit = onInit;

    return;

    function onInit() {
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/fields/field/field.directive.js